import React, { PureComponent } from 'react';

import styles from './styles.less';
import Icon from '~/UI/Icon';
import { TailwindTooltip } from '~/libs/ui/atoms/TailwindTooltip/TailwindTooltip';

interface Props {
	style: any;
}

export default class Header extends PureComponent<Props> {
	static defaultProps = {
		style: null,
	};

	render() {
		const { style } = this.props;

		return (
			<div className={styles.header} style={style}>
				<div className={styles.addOrRemoveCell} />
				<div className={styles.countryCell}>Country</div>
				<div className={styles.brandCell}>Brand name</div>
				<div className={styles.mahCell}>Company</div>
				<div className={styles.dosageCell}>Dosage Form</div>
				<div className={styles.dosageStrengthCell}>Dosage strength</div>
				<div className={styles.packageCell}>Package</div>
				<div className={styles.referencePriceCell}>
					Price
					<TailwindTooltip
						reference={<Icon name='violet-question-mark' />}
						displayClass='inline-block ml-2 h-4 align-top'
						position='left'
					>
						<p className='leading-snug'>
							<strong>Horná cena:</strong> Stanovená Ex-factory cena (zverejnená, alebo spočtená)
						</p>
						<p className='leading-snug'>
							<strong>Spodná cena (tučným písmom):</strong> Pôvodná cena zverejnená vo zdroji (Ex-factory price, alebo
							cena slúžiace pro prepočet na Ex-factory price)
						</p>
					</TailwindTooltip>
				</div>
				<div className={styles.packageForCalculationCell}>Package for calc.</div>
				<div className={styles.comparativePriceCell}>
					Calc. Price
					<TailwindTooltip
						reference={<Icon name='violet-question-mark' />}
						displayClass='inline-block ml-2 h-4 align-top'
						position='left'
					>
						<p className='leading-snug'>
							<strong>Calc. price:</strong> Cena získaná vynásobením ceny (pole Price) veľkosťou balenia (pole Package
							for calc.)
						</p>
						<p className='leading-snug'>
							<strong>Horná cena:</strong> Stanovená Ex-factory cena (zverejnená, alebo spočtená)
						</p>
						<p className='leading-snug'>
							<strong>Spodná cena (tučným písmom):</strong> Pôvodná cena zverejnená vo zdroji (Ex-factory price, alebo
							cena slúžiace pro prepočet na Ex-factory price)
						</p>
					</TailwindTooltip>
				</div>
				<div className={styles.selectionCell}>Use for calc.</div>
				<div className={styles.usedForCalculationCell} />
			</div>
		);
	}
}
